// Use DOMContentLoaded instead of turbo:load since Turbo is disabled in layout
function initUsersDataTable() {
  const table = $("#users-datatable");
  
  // Check if table exists on this page
  if (table.length === 0) {
    return;
  }
  
  // Destroy existing DataTable if it exists to prevent double initialization
  if ($.fn.DataTable.isDataTable('#users-datatable')) {
    table.DataTable().destroy();
  }
  
  try {
    table.dataTable({
      responsive: {
        details: {
          type: 'column',
          target: 'tr'
        }
      },
      scrollCollapse: true,
      sDom: '<"row view-filter txt"<"col-sm-12 txt"<"pull-left txt"l><"pull-right txt"f><"clearfix txt">>>t<"row view-pager txt"<"col-sm-12 p-2 txt"<"text-center txt"p>>>',
      processing: true,
      serverSide: true,
      pageLength: 10,
      language: {
        stripClasses: "",
        search: '<span class="txt text-sm mr-2 mt-2">Search</span>',
        searchPlaceholder: "Enter Keywords Here...",
        lengthMenu:
          '<span class="float-right txt text-sm mt-1">Rows per page</span><select class="float-right mr-2 input input-sm rounded-sm">' +
          '<option value="10">10</option>' +
          '<option value="20">20</option>' +
          '<option value="30">30</option>' +
          '<option value="40">40</option>' +
          '<option value="50">50</option>' +
          '<option value="100">100</option>' +
          "</select>",
      },
      ajax: {
        url: table.data("source"),
        error: function(xhr, error, code) {
          console.error('DataTables AJAX error:', error, code);
          console.error('Response:', xhr.responseText);
        }
      },
      pagingType: "simple_numbers",
      columns: [
        { 
          data: "email",
          className: "all",
          responsivePriority: 1
        },
        { 
          data: "name",
          responsivePriority: 2
        },
        { 
          data: "jock_id",
          responsivePriority: 4,
          className: "desktop"
        },
        { 
          data: "role",
          responsivePriority: 3
        },
        { 
          data: "markets",
          orderable: false,
          responsivePriority: 5,
          className: "desktop tablet-l"
        },
        { 
          data: "actions",
          orderable: false,
          className: "all",
          responsivePriority: 1
        }
      ]
    });
  } catch (error) {
    console.error('DataTables initialization error:', error);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initUsersDataTable);

// Also listen for turbo events in case Turbo gets enabled later
document.addEventListener('turbo:load', initUsersDataTable);

// Clean up before page cache
document.addEventListener("turbo:before-cache", function() {
  if ($.fn.DataTable.isDataTable('#users-datatable')) {
    $("#users-datatable").DataTable().destroy();
  }
});